import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <>
      {/* DESKTOP */}
      <div className="hidden md:flex justify-center mt-8">
        <div className="flex items-center gap-1 bg-gray-100 p-1 rounded-xl shadow-sm">
          {/* PREV */}
          <button
            onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
            disabled={currentPage === 1}
            className={`w-9 h-9 flex items-center justify-center rounded-lg transition ${
              currentPage === 1
                ? "text-gray-300 cursor-not-allowed"
                : "text-gray-600 hover:bg-gray-200"
            }`}
          >
            <ChevronLeft size={18} />
          </button>

          {/* PAGE NUMBERS */}
          {Array.from({ length: totalPages })
            .map((_, i) => i + 1)
            .filter((page) => {
              return (
                page === 1 ||
                page === totalPages ||
                Math.abs(page - currentPage) <= 1
              );
            })
            .map((page, index, arr) => {
              const prevPage = arr[index - 1];

              return (
                <React.Fragment key={page}>
                  {/* DOTS */}
                  {prevPage && page - prevPage > 1 && (
                    <span className="px-2 text-gray-400">...</span>
                  )}

                  {/* PAGE BUTTON */}
                  <button
                    onClick={() => onPageChange(page)}
                    className={`min-w-[36px] h-9 px-2 flex items-center justify-center rounded-lg text-sm font-medium transition ${
                      currentPage === page
                        ? "bg-navy text-yellowstar shadow"
                        : "text-gray-600 hover:bg-gray-200"
                    }`}
                  >
                    {page}
                  </button>
                </React.Fragment>
              );
            })}

          {/* NEXT */}
          <button
            onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
            disabled={currentPage === totalPages}
            className={`w-9 h-9 flex items-center justify-center rounded-lg transition ${
              currentPage === totalPages
                ? "text-gray-300 cursor-not-allowed"
                : "text-gray-600 hover:bg-gray-200"
            }`}
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>

      {/* MOBILE */}
      <div className="md:hidden flex items-center justify-center mb-5 mt-5">
        <div className="flex items-center gap-3 bg-gray-100 rounded-full px-4 py-2 shadow-sm">
          {/* PREV */}
          <button
            onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
            disabled={currentPage === 1}
            className={`px-3 py-1 text-sm rounded-full transition ${
              currentPage === 1
                ? "text-gray-300 cursor-not-allowed"
                : "text-gray-600 hover:bg-gray-200"
            }`}
          >
            ←
          </button>

          {/* INFO */}
          <span className="text-sm font-medium text-gray-700">
            {currentPage} / {totalPages}
          </span>

          {/* NEXT */}
          <button
            onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
            disabled={currentPage === totalPages}
            className={`px-3 py-1 text-sm rounded-full transition ${
              currentPage === totalPages
                ? "text-gray-300 cursor-not-allowed"
                : "text-gray-600 hover:bg-gray-200"
            }`}
          >
            →
          </button>
        </div>
      </div>
    </>
  );
};

export default Pagination;
